import { Accordion, Button, Modal, Spinner } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';
import DOMPurify from 'dompurify';
import moment from 'moment';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useChallengePosts, useApproveChallengePost, useUpdateChallengePost } from '../apis/knackchallenge';  // Import the new hook
import Swal from 'sweetalert2';
import axios from 'axios';
import noDataImage from "../assets/nodata.png"
import { renderMedia } from './services/service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faImage, faImages, faSpinner, faUpload, faDownload } from '@fortawesome/free-solid-svg-icons';
import { getEnabledPlatforms } from '../utils/platformUtils';
import { validateInstagramImageUrl } from '../utils/instagramValidation';
const ChallengePostList = ({ challengeId, userId, status }) => {
    const { data, isLoading, error, refetch } = useChallengePosts(
        challengeId,
        userId,
        status
    );
    const { mutateAsync: approvePost } = useApproveChallengePost();

    const { mutate: updatePost, isLoading: updateisLoading, data: updateData } = useUpdateChallengePost();  // New mutation hook for updating post

    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedPost, setSelectedPost] = useState(null);
    const [editingPostID, setEditingPostID] = useState(null);
    const [editedContext, setEditedContext] = useState('');
    const [selectedImageUrl, setSelectedImageUrl] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMaximized, setIsMaximized] = useState(false);
    const [image, setImage] = useState(null);
    const [selectedImagename, setSelectedImagename] = useState('');
    const [imagePreview, setImagePreview] = useState(null);
    const [videoPreview, setVideoPreview] = useState(null);
    const [fetchedImagesMap, setFetchedImagesMap] = useState({});
    const [imageKeywordsMap, setImageKeywordsMap] = useState({}); // Keywords per post ID
    const [isFetchingImagesMap, setIsFetchingImagesMap] = useState({}); // Loading state per post ID
    const [isRefreshingImagesMap, setIsRefreshingImagesMap] = useState({}); // Refresh loading per post ID
    const [isCraftingVisualMap, setIsCraftingVisualMap] = useState({}); // Craft Visual loading per post ID
    const options = { ALLOWED_TAGS: [] }
    const fileInputRef = useRef(null);
    const [enabledPlatforms, setEnabledPlatforms] = useState([]);
    const [platformsLoading, setPlatformsLoading] = useState(true);

    // Fetch enabled platforms for challenges module
    useEffect(() => {
        const fetchPlatforms = async () => {
            setPlatformsLoading(true);
            const platforms = await getEnabledPlatforms('knackChallenges');
            setEnabledPlatforms(platforms);
            setPlatformsLoading(false);
        };
        fetchPlatforms();
    }, []);

    const handleSelectSuggestedImage = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setSelectedImagename(imageUrl);
        setImage(null);
        setImagePreview(null);
        setVideoPreview(null);
    };

    const handleDownloadImage = async (imageUrl, e) => {
        e.stopPropagation();
        try {
            // Fetch the image
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            
            // Create a download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            
            // Extract filename from URL or use default
            const urlParts = imageUrl.split('/');
            const filename = urlParts[urlParts.length - 1].split('?')[0] || 'downloaded-image.jpg';
            link.download = filename;
            
            // Trigger download
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading image:', error);
        }
    };

    function convert(htmlString, options) {
        const clean = DOMPurify.sanitize(htmlString, options);

        return clean;
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        
        // If no file selected (user cancelled), clear everything
        if (!file) {
            setImage(null);
            setSelectedImagename('');
            setImagePreview(null);
            setVideoPreview(null);
            return;
        }
        
        const maxSize = 50 * 1024 * 1024; // 50 MB in bytes

        if (file.size > maxSize) {
            Swal.fire({
                icon: 'error',
                title: 'File Size Exceeded',
                text: 'The file size should not exceed 50 MB.',
                showConfirmButton: true,
            });
            setImage(null);
            setSelectedImagename('');
            setImagePreview(null);
            setVideoPreview(null);
            return;
        }
        
        // File is valid, proceed with setting it
            setImage(file);
        setSelectedImagename(file.name || '');
        // Clear selected image when uploading file
        setSelectedImageUrl(null);
        
        console.log('File selected:', file.name, 'Type:', file.type);
        
        // Create preview for image files
        if (file.type && file.type.startsWith('image/')) {
            console.log('Processing image file...');
            const reader = new FileReader();
            reader.onload = (e) => {
                const result = e.target?.result || reader.result;
                console.log('Image preview loaded:', result ? 'Success' : 'Failed', 'Type:', file.type, 'Result length:', result?.length);
                if (result) {
                    setImagePreview(result);
                    setVideoPreview(null); // Clear video preview when image is selected
                    console.log('Image preview state set');
                } else {
                    console.error('No result from FileReader for image');
                }
            };
            reader.onerror = (error) => {
                console.error('Error reading image file:', error);
                setImagePreview(null);
            };
            reader.readAsDataURL(file);
        } else if (file.type && file.type.startsWith('video/')) {
            console.log('Processing video file...');
            // Create preview for video files
            const reader = new FileReader();
            reader.onload = (e) => {
                const result = e.target?.result || reader.result;
                console.log('Video preview loaded:', result ? 'Success' : 'Failed');
                if (result) {
                    setVideoPreview(result);
                    setImagePreview(null); // Clear image preview when video is selected
                }
            };
            reader.onerror = () => {
                console.error('Error reading video file');
                setVideoPreview(null);
            };
            reader.readAsDataURL(file);
        } else {
            console.log('Unknown file type:', file.type);
            setImagePreview(null);
            setVideoPreview(null);
        }
    };


    const handleApproveClick = (ChallengePostID) => {
        setSelectedPost(data.find(p => p.ChallengePostID === ChallengePostID));
        setShowConfirm(true);
    };

    const confirmApprove = async () => {
        try {
            // Wait for platforms to load if still loading
            if (platformsLoading) {
                await Swal.fire({
                    icon: 'info',
                    title: 'Loading Platform Settings',
                    text: 'Please wait while we check platform settings...',
                    showConfirmButton: false,
                    timer: 1000,
                });
                // Wait a bit more for platforms to load
                await new Promise(resolve => setTimeout(resolve, 500));
            }

            // Check if Instagram is enabled and validate image
            const isInstagramEnabled = enabledPlatforms.some(p => p.code === 'instagram' || p.name?.toLowerCase() === 'instagram');
            // Check multiple possible image field names (Image, image, ImageURL, etc.)
            const postImage = selectedPost?.Image || selectedPost?.image || selectedPost?.ImageURL || selectedPost?.PostImage || selectedPost?.MediaURL || null;
            const hasImage = !!(postImage && postImage.trim() !== '' && postImage !== 'null' && postImage !== 'undefined');
            console.log("hasImage", hasImage, "postImage", postImage, "isInstagramEnabled", isInstagramEnabled);
            
            if (isInstagramEnabled && !hasImage) {
                await Swal.fire({
                    icon: 'error',
                    title: 'Image Required for Instagram',
                    html: `
                        <div style="text-align: left;">
                            <p style="margin-bottom: 15px;"><strong>Instagram requires an image to post.</strong></p>
                            <p style="margin-bottom: 20px; color: #666;">This challenge post does not have an image. Please edit this post and add an image before approving for Instagram.</p>
                        </div>
                    `,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#2e3192',
                });
                setShowConfirm(false);
                setSelectedPost(null);
                return;
            }

            // Validate Instagram image aspect ratio if Instagram is enabled and image exists
            // if (isInstagramEnabled && hasImage) {
            //     try {
            //         const fullImageUrl = postImage.startsWith('http') ? postImage : `${process.env.REACT_APP_API_BASE_URL}/${postImage}`;
            //         const validationResult = await validateInstagramImageUrl(fullImageUrl);
                    
            //         if (validationResult && !validationResult.isValid) {
            //             await Swal.fire({
            //                 icon: 'error',
            //                 title: 'Invalid Image Aspect Ratio for Instagram',
            //                 html: `
            //                     <div style="text-align: left;">
            //                         <p style="margin-bottom: 15px;"><strong>${validationResult.error || 'Image does not meet Instagram requirements.'}</strong></p>
            //                         <p style="margin-bottom: 20px; color: #666;">Instagram requires images with aspect ratios between 0.8:1 and 1.91:1 (approximately 4:5 portrait to 1.91:1 landscape).</p>
            //                         <p style="color: #666;">Please edit this post and select a different image with a valid aspect ratio.</p>
            //                     </div>
            //                 `,
            //                 confirmButtonText: 'OK',
            //                 confirmButtonColor: '#2e3192',
            //             });
            //             setShowConfirm(false);
            //             setSelectedPost(null);
            //             return;
            //         }
            //     } catch (validationError) {
            //         console.error('Error validating Instagram image:', validationError);
            //         // If validation fails due to technical issues, warn but allow to proceed
            //         // (backend will catch it anyway)
            //         const result = await Swal.fire({
            //             icon: 'warning',
            //             title: 'Image Validation Warning',
            //             text: 'Unable to validate image aspect ratio. The post will be approved, but Instagram may reject it if the aspect ratio is invalid.',
            //             confirmButtonText: 'Continue',
            //             confirmButtonColor: '#2e3192',
            //             showCancelButton: true,
            //             cancelButtonText: 'Cancel',
            //             cancelButtonColor: '#6c757d',
            //         });
                    
            //         if (!result.isConfirmed) {
            //             setShowConfirm(false);
            //             setSelectedPost(null);
            //             return;
            //         }
            //     }
            // }

            console.log("🔄 Starting approval for PostID:", selectedPost?.ChallengePostID);

            const response = await approvePost({
                challengePostID: selectedPost.ChallengePostID,
                status: 2,
            });

            console.log("✅ Response from approvePost:", response);

            if (response?.message?.includes("approved")) {


                console.log("🎉 Post approved successfully!");
                setShowConfirm(false);
                setSelectedPost(null);
                Swal.fire({
                    icon: 'success',
                    title: 'Post approved successfully!',
                    showConfirmButton: false,
                    timer: 2000,
                });
                console.log("🔄 Refetching posts...");
                refetch();
            } else {
                console.warn("❌ Approval response received, but not successful:", response);
                Swal.fire({
                    icon: 'error',
                    title: 'Approval Failed',
                    text: response?.message || 'Post could not be approved.',
                });
            }
        } catch (error) {
            console.error("💥 Error occurred during post approval:", error);
            Swal.fire({
                icon: 'error',
                title: 'Something went wrong',
                text: error.message || 'Unexpected error.',
            });
        }
    };

    const validateImage = async (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            const timeout = setTimeout(() => {
                resolve(null); // Timeout after 3 seconds
            }, 3000);
            
            img.onload = () => {
                clearTimeout(timeout);
                resolve(url);
            };
            img.onerror = () => {
                clearTimeout(timeout);
                resolve(null);
            };
            img.src = url;
        });
    };
    const fetchImagesForTags = async (tagsOrTitle) => {
        if (!tagsOrTitle) return [];
        
        // Handle both array of tags and single title/string
        const query = Array.isArray(tagsOrTitle) ? tagsOrTitle.join(" ") : tagsOrTitle;
        
        try {
            const response = await axios.get("https://www.googleapis.com/customsearch/v1", {
                params: {
                    key: process.env.REACT_APP_GOOGLE_API_KEY,
                    cx: process.env.REACT_APP_GOOGLE_CSE_ID,
                    q: query,
                    searchType: "image",
                    num: 10,
                    rights: 'cc_publicdomain,cc_attribute',
                    safe: 'active',
                },
            });

            if (response.data.items) {
                // Validate only first 8 images in parallel (faster), with timeout
                const itemsToValidate = response.data.items.slice(0, 8);
                const imageLinks = await Promise.all(
                    itemsToValidate.map((item) => validateImage(item.link))
                );
                return imageLinks.filter(link => link !== null);
            }
            return [];
        } catch (error) {
            console.error("Error fetching images:", error);
            return [];
        }
    };

    // Extract keywords from content for better image search
    const extractKeywordsFromContent = (content, challengeTopic) => {
        const keywords = [];
        
        // 1. Always include the challenge topic (most relevant)
        if (challengeTopic?.trim()) {
            const topicWords = challengeTopic
                .split(/\s+/)
                .filter(word => word.length > 3 && !['the', 'and', 'for', 'are', 'but', 'not', 'you', 'all', 'can', 'her', 'was', 'one', 'our', 'out', 'day', 'get', 'has', 'him', 'his', 'how', 'its', 'may', 'new', 'now', 'old', 'see', 'two', 'way', 'who', 'boy', 'did', 'she', 'use', 'her', 'many', 'than', 'them'].includes(word.toLowerCase()))
                .slice(0, 5);
            keywords.push(...topicWords);
        }
        
        // 2. Extract hashtags from content
        const hashtags = content.match(/#[\w]+/g) || [];
        keywords.push(...hashtags.map(tag => tag.replace('#', '')));
        
        // 3. Extract key nouns/phrases from content
        const capitalizedWords = content.match(/\b[A-Z][a-z]+\b/g) || [];
        keywords.push(...capitalizedWords.slice(0, 3));
        
        // Remove duplicates and limit to 5-7 keywords
        const uniqueKeywords = [...new Set(keywords)].slice(0, 7);
        return uniqueKeywords.filter(k => k && k.length > 2);
    };

    // Function to fetch images with current keywords for a specific post
    const fetchImagesWithKeywords = async (postID, content, challengeTopic, isRefresh = false) => {
        if (!content?.trim()) {
            // Clear loading states if no content
            setIsFetchingImagesMap(prev => ({ ...prev, [postID]: false }));
            setIsRefreshingImagesMap(prev => ({ ...prev, [postID]: false }));
            setIsCraftingVisualMap(prev => ({ ...prev, [postID]: false }));
            return;
        }
        
        // Clean HTML tags from content for keyword extraction
        const cleanContent = content
            .replace(/<br\s*\/?>/gi, ' ')
            .replace(/<\/?[^>]+(>|$)/g, ' ') // Remove all HTML tags
            .replace(/\s+/g, ' ')
            .trim();
        
        if (!cleanContent) {
            // Clear loading states if no clean content
            setIsFetchingImagesMap(prev => ({ ...prev, [postID]: false }));
            setIsRefreshingImagesMap(prev => ({ ...prev, [postID]: false }));
            setIsCraftingVisualMap(prev => ({ ...prev, [postID]: false }));
            setFetchedImagesMap(prev => ({ ...prev, [postID]: [] }));
            return;
        }
        
        // Set appropriate loading state based on which button was clicked
        if (isRefresh) {
            setIsRefreshingImagesMap(prev => ({ ...prev, [postID]: true }));
        } else if (imageKeywordsMap[postID]?.trim()) {
            setIsCraftingVisualMap(prev => ({ ...prev, [postID]: true }));
        } else {
            setIsFetchingImagesMap(prev => ({ ...prev, [postID]: true }));
        }
        
        try {
            // If user has manually entered keywords, use those
            if (imageKeywordsMap[postID]?.trim() && !isRefresh) {
                const manualKeywords = imageKeywordsMap[postID].split(',').map(k => k.trim()).filter(k => k);
                const images = await fetchImagesForTags(manualKeywords);
                setFetchedImagesMap(prev => ({ ...prev, [postID]: images }));
                setIsCraftingVisualMap(prev => ({ ...prev, [postID]: false }));
                return;
            }
            
            // Otherwise, use improved automatic extraction
            const extractedKeywords = extractKeywordsFromContent(cleanContent, challengeTopic);
            console.log('Extracted keywords for images:', extractedKeywords);
            
            if (extractedKeywords.length > 0) {
                const images = await fetchImagesForTags(extractedKeywords);
                setFetchedImagesMap(prev => ({ ...prev, [postID]: images }));
            } else {
                // Fast fallback: use challenge topic or first few words from content
                const fallbackKeywords = challengeTopic 
                    ? challengeTopic.split(/\s+/).filter(w => w.length > 3).slice(0, 3)
                    : cleanContent.split(/\s+/).filter(w => w.length > 3).slice(0, 3);
                
                if (fallbackKeywords.length > 0) {
                    const images = await fetchImagesForTags(fallbackKeywords);
                    setFetchedImagesMap(prev => ({ ...prev, [postID]: images }));
                } else {
                    // Last resort: use hashtags from content
                    const hashtags = cleanContent.match(/#[\w]+/g) || [];
                    if (hashtags.length > 0) {
                        const images = await fetchImagesForTags(hashtags.map(tag => tag.replace('#', '')));
                        setFetchedImagesMap(prev => ({ ...prev, [postID]: images }));
                    } else {
                        setFetchedImagesMap(prev => ({ ...prev, [postID]: [] }));
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching images:', error);
            setFetchedImagesMap(prev => ({ ...prev, [postID]: [] }));
        } finally {
            setIsFetchingImagesMap(prev => ({ ...prev, [postID]: false }));
            setIsRefreshingImagesMap(prev => ({ ...prev, [postID]: false }));
            setIsCraftingVisualMap(prev => ({ ...prev, [postID]: false }));
        }
    };

    const generateTitle = async (content) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/generate-title`, {
                content,
            });

            return response.data.title;
        } catch (error) {
            console.error("Failed to generate title:", error.message);
            return "Untitled";
        }
    };
    const handleEditClick = async (post) => {
        setEditingPostID(post.ChallengePostID);
        // Clear keywords when starting to edit
        setImageKeywordsMap(prev => ({ ...prev, [post.ChallengePostID]: '' }));
        
        // Set edited context immediately (don't wait for images)
        setEditedContext(
            post.ChallengePostContext.replace(/<br\s*\/?>/gi, '\n') // convert <br> back to \n for editing
        );
        
        // Fetch images in background (non-blocking) if not already cached
        if (!fetchedImagesMap[post.ChallengePostID]) {
            // Clean HTML tags from content for keyword extraction
            const cleanContent = post?.ChallengePostContext 
                ? post.ChallengePostContext
                    .replace(/<br\s*\/?>/gi, ' ')
                    .replace(/<\/?[^>]+(>|$)/g, ' ') // Remove all HTML tags
                    .replace(/\s+/g, ' ')
                    .trim()
                : '';
            
            if (cleanContent) {
                // Don't await - let it fetch in background
                fetchImagesWithKeywords(
                    post.ChallengePostID,
                    cleanContent,
                    post.ChallengePostTitle || ''
                ).catch(error => {
                    console.error('Background image fetch failed:', error);
                });
            }
        }
    };

    const handleCancelEdit = () => {
        const currentPostID = editingPostID;
        setEditingPostID(null);
        setEditedContext('');
        setImage(null);
        setSelectedImagename('');
        setImagePreview(null);
        setVideoPreview(null);
        setSelectedImageUrl(null);
        // Clear keywords for the canceled post
        if (currentPostID) {
            setImageKeywordsMap(prev => {
                const updated = { ...prev };
                delete updated[currentPostID];
                return updated;
            });
        }
    };

    const handleSaveClick = async (postID) => {
        // Wait for platforms to load if still loading
        if (platformsLoading) {
            await Swal.fire({
                icon: 'info',
                title: 'Loading Platform Settings',
                text: 'Please wait while we check platform settings...',
                showConfirmButton: false,
                timer: 1000,
            });
            // Wait a bit more for platforms to load
            await new Promise(resolve => setTimeout(resolve, 500));
        }

        // Check if Instagram is enabled and validate image
        const isInstagramEnabled = enabledPlatforms.some(p => p.code === 'instagram' || p.name?.toLowerCase() === 'instagram');
        
        // Check if image exists (checking new image upload, selected AI image, or existing image name)
        const hasNewImage = !!(image || selectedImageUrl || (selectedImagename && selectedImagename.trim() !== '' && selectedImagename !== 'null' && selectedImagename !== 'undefined'));
        
        // Also check existing post image if no new image is being added
        const currentPost = data?.find(p => p.ChallengePostID === postID);
        const existingPostImage = currentPost?.Image || currentPost?.image || currentPost?.ImageURL || currentPost?.PostImage || currentPost?.MediaURL || null;
        const hasExistingImage = !!(existingPostImage && existingPostImage.trim() !== '' && existingPostImage !== 'null' && existingPostImage !== 'undefined');
        
        const hasImage = hasNewImage || hasExistingImage;
        
        // Determine which image to validate (prioritize new image over existing)
        let imageToValidate = null;
        let tempObjectUrl = null;
        
        if (image) {
            // Create temporary object URL for file upload validation
            tempObjectUrl = URL.createObjectURL(image);
            imageToValidate = tempObjectUrl;
        } else if (selectedImageUrl) {
            imageToValidate = selectedImageUrl;
        } else if (hasExistingImage) {
            imageToValidate = existingPostImage;
        }
        
        console.log("Save validation - hasImage:", hasImage, "isInstagramEnabled:", isInstagramEnabled, "imageToValidate:", imageToValidate);
        
        if (isInstagramEnabled && !hasImage) {
            await Swal.fire({
                icon: 'error',
                title: 'Image Required for Instagram',
                html: `
                    <div style="text-align: left;">
                        <p style="margin-bottom: 15px;"><strong>Instagram requires an image to post.</strong></p>
                        <p style="margin-bottom: 20px; color: #666;">This challenge post does not have an image. Please add an image before saving for Instagram.</p>
                    </div>
                `,
                confirmButtonText: 'OK',
                confirmButtonColor: '#2e3192',
            });
            return;
        }

        // Validate Instagram image aspect ratio if Instagram is enabled and image exists
        if (isInstagramEnabled && hasImage && imageToValidate) {
            try {
                // For file uploads, use the object URL directly; for URLs, check if it needs base URL prefix
                const fullImageUrl = tempObjectUrl 
                    ? imageToValidate 
                    : (imageToValidate.startsWith('http') ? imageToValidate : `${process.env.REACT_APP_API_BASE_URL}/${imageToValidate}`);
                
                const validationResult = await validateInstagramImageUrl(fullImageUrl);
                
                // Clean up temporary object URL if we created one
                if (tempObjectUrl) {
                    URL.revokeObjectURL(tempObjectUrl);
                    tempObjectUrl = null;
                }
                
                if (validationResult && !validationResult.isValid) {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Invalid Image Aspect Ratio for Instagram',
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 15px;"><strong>${validationResult.error || 'Image does not meet Instagram requirements.'}</strong></p>
                                <p style="margin-bottom: 20px; color: #666;">Instagram requires images with aspect ratios between 0.8:1 and 1.91:1 (approximately 4:5 portrait to 1.91:1 landscape).</p>
                                <p style="color: #666;">Please select a different image with a valid aspect ratio.</p>
                            </div>
                        `,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192',
                    });
                    return;
                }
            } catch (validationError) {
                // Clean up temporary object URL if we created one
                if (tempObjectUrl) {
                    URL.revokeObjectURL(tempObjectUrl);
                    tempObjectUrl = null;
                }
                
                console.error('Error validating Instagram image:', validationError);
                // If validation fails due to technical issues, warn but allow to proceed
                // (backend will catch it anyway)
                const result = await Swal.fire({
                    icon: 'warning',
                    title: 'Image Validation Warning',
                    text: 'Unable to validate image aspect ratio. The post will be saved, but Instagram may reject it if the aspect ratio is invalid.',
                    confirmButtonText: 'Continue',
                    confirmButtonColor: '#2e3192',
                    showCancelButton: true,
                    cancelButtonText: 'Cancel',
                    cancelButtonColor: '#6c757d',
                });
                
                if (!result.isConfirmed) {
                    return;
                }
            }
        }

        // Prepare the data to update
        const updatedPost = {
            ChallengePostID: postID,
            ChallengePostContext: convert(editedContext, options),
        };
        const formData = new FormData();
        formData.append('ChallengePostID', postID);
        formData.append('ChallengePostContext', convert(editedContext, options));
        if (image) {
            formData.append('image', image); // Upload directly if it's a file
        } else if (selectedImageUrl) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/download-image?url=${encodeURIComponent(selectedImageUrl)}`);
                const blob = await response.blob();  // Convert to Blob
                const fileName = `image_${Date.now()}.jpg`; // Generate a filename
                const file = new File([blob], fileName, { type: blob.type }); // Create a File object

                formData.append('image', file); // Append the file to FormData
            } catch (error) {
                console.error("Error downloading image:", error);
                // Alert the user if there is a CORS error or any other issue during image fetch
                Swal.fire({
                    icon: 'error',
                    title: 'Image Fetch Error',
                    text: 'There was an issue fetching the image. Please try again later.',
                });
                return;
            }
        } else {
            formData.append('image', selectedImagename || '');
        }
        updatePost(
            { formData, ChallengePostID: postID },
            {
                onSuccess: (data) => {
                    if (data?.message === 'Post updated successfully') {
                        Swal.fire({
                            icon: 'success',
                            title: 'Post updated successfully!',
                            showConfirmButton: false,
                            timer: 2000,
                        });

                        refetch();
                        setEditingPostID(null);
                        setEditedContext('');
                    }
                },
                onError: (error) => {
                    console.error('Error saving the post:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Failed to save the post.',
                        showConfirmButton: false,
                        timer: 3000,
                    });
                },
            }
        );
    };


    const truncateHalf = (text = '') => {
        const halfLength = Math.floor(text.length / 2);
        return text.slice(0, halfLength) + '...';
    };

    const isTodayOrTomorrow = (postDate) => {
        console.log("Post Date:", postDate);
        const postMoment = moment.utc(postDate);
        console.log("Post Moment:", postMoment);
        return (
            postMoment.isSameOrAfter(moment.utc().startOf('day')) &&
            postMoment.isBefore(moment.utc().add(2, 'days').startOf('day'))
        );
    };

    if (isLoading) return <div>Loading... {status}</div>;
    if (error) return <div>Error fetching challenge posts</div>;
    return (
        <>
            {data.length === 0 ? (
                <div style={{ textAlign: 'center' }}>
                    <img src={noDataImage} alt="No Data" style={{ width: '50%' }} />
                    <p style={{ color: '#2e3192', fontSize: '20px' }}>No posts available</p>
                </div>
            ) : (<Accordion>
                {data?.map((post, index) => (
                    <Accordion.Item
                        eventKey={index.toString()}
                        key={post.ChallengePostID}
                    >
                        <Accordion.Header>
                            Day {post.Sequence}{' '}
                            {post.ChallengePostTitle}
                        </Accordion.Header>
                        <Accordion.Body >
                            {editingPostID === post.ChallengePostID ? (
                                <div>
                                    <p>
                                        <strong style={{ marginRight: 10 }}>Title:</strong>
                                        <span>{post.ChallengePostTitle}</span>
                                    </p>

                                    <textarea
                                        value={editedContext}
                                        onChange={(e) => setEditedContext(e.target.value)}
                                        className="mb-6"
                                        style={{
                                            fontSize: '15px',
                                            borderRadius: '8px',
                                            border: '1px solid #cfeafb',
                                            background: '#FFFFFF',
                                            height: '400px',
                                            width: "100%",
                                            padding: '0px 20px',
                                            fontSize: '16px',
                                        }} />
                                    
                                    {/* AI Media Suggestions Section */}
                                    {editedContext?.trim() && (
                                        <div style={{ marginTop: '20px', marginBottom: '16px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                                                <h5 style={{ 
                                                    color: '#1a202c', 
                                                    fontWeight: '600', 
                                                    marginBottom: '0',
                                                    fontSize: '1.1rem'
                                                }}>
                                                    AI Media Suggestions
                                                </h5>
                                                <button
                                                    onClick={async () => {
                                                        setImageKeywordsMap(prev => ({ ...prev, [post.ChallengePostID]: '' }));
                                                        // Clean HTML tags from editedContext
                                                        const cleanContent = editedContext
                                                            .replace(/<br\s*\/?>/gi, ' ')
                                                            .replace(/<\/?[^>]+(>|$)/g, ' ')
                                                            .replace(/\s+/g, ' ')
                                                            .trim();
                                                        await fetchImagesWithKeywords(
                                                            post.ChallengePostID,
                                                            cleanContent,
                                                            post.ChallengePostTitle || '',
                                                            true
                                                        );
                                                    }}
                                                    disabled={
                                                        (isRefreshingImagesMap[post.ChallengePostID] || 
                                                         isCraftingVisualMap[post.ChallengePostID] || 
                                                         !editedContext?.trim())
                                                    }
                                                    style={{
                                                        background: (isRefreshingImagesMap[post.ChallengePostID] || isCraftingVisualMap[post.ChallengePostID] || !editedContext?.trim()) ? '#cccccc' : '#2e3192',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        padding: '6px 12px',
                                                        color: 'white',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        cursor: (isRefreshingImagesMap[post.ChallengePostID] || isCraftingVisualMap[post.ChallengePostID] || !editedContext?.trim()) ? 'not-allowed' : 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (!isRefreshingImagesMap[post.ChallengePostID] && !isCraftingVisualMap[post.ChallengePostID] && editedContext?.trim()) {
                                                            e.target.style.backgroundColor = '#1a1d5c';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!isRefreshingImagesMap[post.ChallengePostID] && !isCraftingVisualMap[post.ChallengePostID] && editedContext?.trim()) {
                                                            e.target.style.backgroundColor = '#2e3192';
                                                        }
                                                    }}
                                                    title="Refresh images using auto-extracted keywords from your challenge topic and content"
                                                >
                                                    <FontAwesomeIcon 
                                                        icon={isRefreshingImagesMap[post.ChallengePostID] ? faSpinner : faImages} 
                                                        style={{ 
                                                            fontSize: '12px',
                                                            animation: isRefreshingImagesMap[post.ChallengePostID] ? 'spin 1s linear infinite' : 'none'
                                                        }} 
                                                    />
                                                    {isRefreshingImagesMap[post.ChallengePostID] ? 'Searching...' : 'Refresh'}
                                                </button>
                                            </div>
                                            
                                            {/* Image Keywords Input */}
                                            {editedContext?.trim() && (
                                                <div className="mb-3">
                                                    <label style={{ 
                                                        fontSize: '13px', 
                                                        fontWeight: '500', 
                                                        color: '#2e3192',
                                                        marginBottom: '6px',
                                                        display: 'block'
                                                    }}>
                                                        Image Keywords (Optional - comma-separated)
                                                    </label>
                                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                        <input
                                                            type="text"
                                                            value={imageKeywordsMap[post.ChallengePostID] || ''}
                                                            onChange={(e) => setImageKeywordsMap(prev => ({ ...prev, [post.ChallengePostID]: e.target.value }))}
                                                            placeholder="e.g., business, technology, AI, innovation"
                                                            style={{
                                                                flex: 1,
                                                                fontSize: '14px',
                                                                borderRadius: '6px',
                                                                border: '1px solid #cfeafb',
                                                                background: '#FFFFFF',
                                                                padding: '8px 12px',
                                                                outline: 'none'
                                                            }}
                                                            onKeyDown={async (e) => {
                                                                if (e.key === 'Enter' && imageKeywordsMap[post.ChallengePostID]?.trim()) {
                                                                    // Clean HTML tags from editedContext
                                                                    const cleanContent = editedContext
                                                                        .replace(/<br\s*\/?>/gi, ' ')
                                                                        .replace(/<\/?[^>]+(>|$)/g, ' ')
                                                                        .replace(/\s+/g, ' ')
                                                                        .trim();
                                                                    await fetchImagesWithKeywords(
                                                                        post.ChallengePostID,
                                                                        cleanContent,
                                                                        post.ChallengePostTitle || '',
                                                                        false
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                        <button
                                                            onClick={async () => {
                                                                // Clean HTML tags from editedContext
                                                                const cleanContent = editedContext
                                                                    .replace(/<br\s*\/?>/gi, ' ')
                                                                    .replace(/<\/?[^>]+(>|$)/g, ' ')
                                                                    .replace(/\s+/g, ' ')
                                                                    .trim();
                                                                await fetchImagesWithKeywords(
                                                                    post.ChallengePostID,
                                                                    cleanContent,
                                                                    post.ChallengePostTitle || '',
                                                                    false
                                                                );
                                                            }}
                                                            disabled={
                                                                (isCraftingVisualMap[post.ChallengePostID] || 
                                                                 isRefreshingImagesMap[post.ChallengePostID] || 
                                                                 !imageKeywordsMap[post.ChallengePostID]?.trim())
                                                            }
                                                            style={{
                                                                background: (isCraftingVisualMap[post.ChallengePostID] || isRefreshingImagesMap[post.ChallengePostID] || !imageKeywordsMap[post.ChallengePostID]?.trim()) ? '#cccccc' : '#2e3192',
                                                                border: 'none',
                                                                borderRadius: '6px',
                                                                padding: '8px 16px',
                                                                color: 'white',
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                cursor: (isCraftingVisualMap[post.ChallengePostID] || isRefreshingImagesMap[post.ChallengePostID] || !imageKeywordsMap[post.ChallengePostID]?.trim()) ? 'not-allowed' : 'pointer',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '6px',
                                                                transition: 'all 0.3s ease',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (!isCraftingVisualMap[post.ChallengePostID] && !isRefreshingImagesMap[post.ChallengePostID] && imageKeywordsMap[post.ChallengePostID]?.trim()) {
                                                                    e.target.style.backgroundColor = '#1a1d5c';
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (!isCraftingVisualMap[post.ChallengePostID] && !isRefreshingImagesMap[post.ChallengePostID] && imageKeywordsMap[post.ChallengePostID]?.trim()) {
                                                                    e.target.style.backgroundColor = '#2e3192';
                                                                }
                                                            }}
                                                            title="Generate images using your keywords"
                                                        >
                                                            <FontAwesomeIcon 
                                                                icon={isCraftingVisualMap[post.ChallengePostID] ? faSpinner : faImage} 
                                                                style={{ 
                                                                    fontSize: '12px',
                                                                    animation: isCraftingVisualMap[post.ChallengePostID] ? 'spin 1s linear infinite' : 'none'
                                                                }} 
                                                            />
                                                            {isCraftingVisualMap[post.ChallengePostID] ? 'Crafting...' : 'Craft Visual'}
                                                        </button>
                                                    </div>
                                                    <p style={{ 
                                                        fontSize: '11px', 
                                                        color: '#6c757d', 
                                                        marginTop: '4px',
                                                        marginBottom: '0'
                                                    }}>
                                                        Enter keywords and click "Craft Visual" to generate images, or leave empty and use "Refresh" for auto-extraction
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {(isFetchingImagesMap[post.ChallengePostID] || isRefreshingImagesMap[post.ChallengePostID] || isCraftingVisualMap[post.ChallengePostID]) ? (
                                        <div className="text-center p-4">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mt-2 text-muted small">Fetching images...</p>
                                        </div>
                                    ) : fetchedImagesMap[post.ChallengePostID]?.length > 0 ? (
                                    <div className="row" style={{ gap: '4px', marginTop: '12px' }}>
                                        {fetchedImagesMap[post.ChallengePostID].map((img, index) => (
                                                <div key={index} className="col-4 col-md-3 col-lg-2 col-xl-2">
                                                    <div 
                                                        className="position-relative"
                                                        style={{ 
                                                            aspectRatio: "1",
                                                            borderRadius: "6px",
                                                            overflow: "hidden",
                                                            cursor: "pointer",
                                                            border: selectedImageUrl === img ? "2px solid #2e3192" : "1px solid transparent",
                                                            transition: "all 0.2s ease",
                                                            backgroundColor: "#f7fafc",
                                                            maxWidth: "120px"
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (selectedImageUrl !== img) {
                                                                e.currentTarget.style.borderColor = "#cbd5e0";
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (selectedImageUrl !== img) {
                                                                e.currentTarget.style.borderColor = "transparent";
                                                            }
                                                        }}
                                                        onClick={() => handleSelectSuggestedImage(img)}
                                                    >
                                                        <img
                                                            src={img}
                                                            alt="Suggested"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "cover",
                                                                display: "block"
                                                            }}
                                                        />
                                                        
                                                        {/* Top-right checkbox */}
                                                        <div
                                                            className="position-absolute"
                                                            style={{ 
                                                                top: "6px", 
                                                                right: "6px",
                                                                width: "22px",
                                                                height: "22px",
                                                                borderRadius: "50%",
                                                                backgroundColor: selectedImagename === img ? "#2e3192" : "rgba(255, 255, 255, 0.95)",
                                                                border: selectedImagename === img ? "none" : "2px solid rgba(0, 0, 0, 0.2)",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                cursor: "pointer",
                                                                transition: "all 0.15s ease",
                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)"
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                const newChecked = !(selectedImagename === img);
                                                                setSelectedImagename(newChecked ? img : null);
                                                                setSelectedImageUrl(newChecked ? img : null);
                                                                if (newChecked) {
                                                                    setImage(null);
                                                                    setImagePreview(null);
                                                                    setVideoPreview(null);
                                                                }
                                                            }}
                                                        >
                                                            {selectedImagename === img && (
                                                                <FontAwesomeIcon 
                                                                    icon={faCheck} 
                                                                    style={{ 
                                                                        color: "#fff", 
                                                                        fontSize: "10px"
                                                                    }} 
                                                                />
                                                            )}
                                                    </div>
                                                        
                                                        {/* Bottom action buttons overlay */}
                                                        <div
                                                            className="position-absolute d-flex gap-2"
                                                            style={{
                                                                bottom: "8px",
                                                                left: "50%",
                                                                transform: "translateX(-50%)",
                                                                opacity: selectedImageUrl === img ? "1" : "0",
                                                                transition: "opacity 0.2s ease"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.opacity = "1";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (selectedImageUrl !== img) {
                                                                    e.currentTarget.style.opacity = "0";
                                                                }
                                                            }}
                                                        >
                                                            <button
                                                                className="btn btn-sm"
                                                                style={{
                                                                    minWidth: "32px",
                                                                    height: "32px",
                                                                    padding: "0",
                                                                    borderRadius: "6px",
                                                                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                                                                    border: "none",
                                                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                setSelectedImageUrl(img);
                                                                setIsModalOpen(true);
                                                                }}
                                                                title="View Full Image"
                                                            >
                                                                <FontAwesomeIcon icon={faImage} style={{ color: "#2e3192", fontSize: "12px" }} />
                                                            </button>
                                                            
                                                            <button
                                                                className="btn btn-sm"
                                                                style={{
                                                                    minWidth: "32px",
                                                                    height: "32px",
                                                                    padding: "0",
                                                                    borderRadius: "6px",
                                                                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                                                                    border: "none",
                                                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                                    display: "none",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                                onClick={(e) => handleDownloadImage(img, e)}
                                                                title="Download Image"
                                                            >
                                                                <FontAwesomeIcon icon={faDownload} style={{ color: "#2e3192", fontSize: "12px" }} />
                                                            </button>
                                                        </div>
                                                        
                                                        {/* Hover overlay */}
                                                        {selectedImageUrl !== img && (
                                                            <div
                                                                className="position-absolute"
                                                                style={{
                                                                    top: 0,
                                                                    left: 0,
                                                                    right: 0,
                                                                    bottom: 0,
                                                                    backgroundColor: "rgba(0, 0, 0, 0)",
                                                                    transition: "background-color 0.2s ease",
                                                                    pointerEvents: "none"
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.05)";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0)";
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                    ) : (
                                        <div className="text-center p-4" style={{ 
                                            border: '1px dashed #dee2e6', 
                                            borderRadius: '8px', 
                                            backgroundColor: '#f8f9fa',
                                            color: '#6c757d'
                                        }}>
                                            <FontAwesomeIcon icon={faImage} style={{ fontSize: '2rem', color: '#adb5bd', marginBottom: '10px' }} />
                                            <p className="mb-0 small">
                                                No images found for this content. Try adding hashtags to your prompt or enter keywords.
                                            </p>
                                        </div>
                                    )}

                                    <div className="form-group mt-5 mb-5">
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/*,video/*"
                                            style={{ display: 'none' }}
                                            onChange={(e) => {
                                                handleImageChange(e);
                                                setSelectedImageUrl(null);
                                            }}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => fileInputRef.current?.click()}
                                            title="Upload Image or Video"
                                            style={{
                                                fontSize: '16px',
                                                borderRadius: '50%',
                                                border: 'none',
                                                background: '#2e3192',
                                                padding: '12px',
                                                color: 'white',
                                                fontWeight: 'bold',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '48px',
                                                height: '48px',
                                                minWidth: '48px',
                                                transition: 'all 0.3s ease',
                                                cursor: 'pointer'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#1a1d5c';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = '#2e3192';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faUpload} />
                                        </button>
                                        {(selectedImagename || selectedImageUrl) && (
                                            <div style={{ marginTop: '10px' }}>
                                                <p style={{ marginBottom: '10px', fontWeight: 'bold', color: '#2e3192' }}>
                                                    Selected: {selectedImageUrl ? 'AI Suggested Image' : (image && image.type && image.type.startsWith('video/')) ? 'Uploaded Video' : 'Uploaded Image'}
                                                </p>
                                                {selectedImageUrl ? (
                                                    // Show AI selected image preview
                                                    <div>
                                                        <img
                                                            src={selectedImageUrl}
                                                            alt="Selected AI Image"
                                                            style={{
                                                                width: "150px",
                                                                height: "150px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                border: "2px solid #2e3192"
                                                            }}
                                                            onError={(e) => {
                                                                console.error('Error loading AI image preview:', e);
                                                            }}
                                                            onLoad={() => {
                                                                console.log('AI image preview loaded successfully');
                                                            }}
                                                        />
                                                    </div>
                                                ) : imagePreview ? (
                                                    // Show uploaded image preview
                                                    <div>
                                                        <img
                                                            src={imagePreview}
                                                            alt="Uploaded"
                                                            style={{
                                                                width: "150px",
                                                                height: "150px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                border: "2px solid #2e3192"
                                                            }}
                                                            onError={(e) => {
                                                                console.error('Error loading image preview:', e);
                                                                setImagePreview(null);
                                                            }}
                                                            onLoad={() => {
                                                                console.log('Image preview loaded successfully');
                                                            }}
                                                        />
                                                    </div>
                                                ) : videoPreview ? (
                                                    // Show uploaded video preview
                                                    <div>
                                                        <video
                                                            src={videoPreview}
                                                            controls
                                                            style={{
                                                                width: "200px",
                                                                maxHeight: "200px",
                                                                borderRadius: "8px",
                                                                border: "2px solid #2e3192"
                                                            }}
                                                        >
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    </div>
                                                ) : (
                                                    <p style={{ fontSize: '14px', color: '#666' }}>
                                                        {selectedImagename}
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    {post.Status != 3 && <div className="mt-12">
                                        <Button
                                            variant="success"
                                            onClick={() =>
                                                handleSaveClick(post.ChallengePostID)
                                            }
                                            className="me-2"
                                            disabled={updateisLoading}
                                        >
                                            {updateisLoading ? (
                                                <>
                                                    <Spinner animation="border" role="status" size="sm" className="me-2">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </Spinner>
                                                    Saving...
                                                </>
                                            ) : (
                                                "Save"
                                            )}
                                        </Button>
                                        <Button
                                            variant="secondary"
                                            onClick={handleCancelEdit}
                                            disabled={updateisLoading}
                                        >
                                            Cancel
                                        </Button>
                                    </div>

                                    }
                                </div>
                            ) : (
                                <>
                                    <p>
                                        <strong style={{ marginRight: 10 }}>Title:</strong>
                                        <span>{post.ChallengePostTitle}</span>
                                    </p>
                                    {post?.image != null && <div className='mt-3'><b style={{ color: "#2e3192" }}>Media: </b> {renderMedia(post?.image)}</div>}


                                    <p style={{ whiteSpace: 'pre-line' }}>
                                        {post.ChallengePostContext}
                                    </p>

                                    {/* Disclaimer for image selection */}
                                    {!post?.image && post.Status != 3 && (
                                        <div style={{
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            padding: '12px 16px',
                                            backgroundColor: '#e3f2fd',
                                            border: '1px solid #90caf9',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px'
                                        }}>
                                            <FontAwesomeIcon 
                                                icon={faImage} 
                                                style={{ 
                                                    color: '#1976d2', 
                                                    fontSize: '18px',
                                                    flexShrink: 0
                                                }} 
                                            />
                                            <div style={{ flex: 1 }}>
                                                <p style={{ 
                                                    margin: 0, 
                                                    fontSize: '14px', 
                                                    color: '#1565c0',
                                                    fontWeight: '500'
                                                }}>
                                                    💡 Want to add an image to this post?
                                                </p>
                                                <p style={{ 
                                                    margin: '4px 0 0 0', 
                                                    fontSize: '13px', 
                                                    color: '#424242'
                                                }}>
                                                    Click the <strong style={{ color: '#1976d2' }}>Edit</strong> button below to select an image from AI suggestions or upload your own.
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} size={isMaximized ? "xl" : "lg"} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Image Preview</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="text-center">
                                            <img
                                                src={selectedImageUrl}
                                                alt="Selected"
                                                style={{
                                                    maxWidth: "100%",
                                                    maxHeight: isMaximized ? "90vh" : "70vh",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
                                                Close
                                            </Button>
                                            <Button variant="primary" onClick={() => setIsMaximized(!isMaximized)}>
                                                {isMaximized ? "Minimize" : "Maximize"}
                                            </Button>
                                            <Button variant="success" onClick={() => {
                                                handleSelectSuggestedImage(selectedImageUrl);
                                                setIsModalOpen(false);
                                            }}>
                                                Select Image
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>




                                    <div>
                                        {
                                            post.Status === 1 && (
                                                <Button
                                                    variant="success"
                                                    onClick={() =>
                                                        handleApproveClick(
                                                            post.ChallengePostID
                                                        )
                                                    }
                                                    className="me-2"
                                                >
                                                    Approve
                                                </Button>
                                            )}
                                        {post.Status != 3 && <Button
                                            variant="primary"
                                            onClick={() =>
                                                handleEditClick(post)
                                            }
                                        >
                                            Edit
                                        </Button>
                                        }
                                    </div>
                                </>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>)
            }

            {/* Modal to confirm approval */}
            <Modal
                show={showConfirm}
                onHide={() => setShowConfirm(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Approval</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to approve the post titled:{' '}
                    <strong>{selectedPost?.ChallengePostTitle}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowConfirm(false)}
                    >
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={confirmApprove}>
                        Confirm Approval
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ChallengePostList;
